import Skeleton from '@material-ui/lab/Skeleton';
import { useFormClasses } from 'src/hooks/useFormClasses';

export const SkeletonInput = () => {
  const { classes } = useFormClasses();
  return <Skeleton className={classes.textField} variant="rect" width={470} height={60} />;
};
